<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useMessagesStore } from '@/stores/messages'
import { useConversationsStore } from '@/stores/conversations'
import { useExplanationStore } from '@/stores/explanations'

const explanationStore = useExplanationStore()
const messageStore = useMessagesStore()
const conversationsStore = useConversationsStore()
const router = useRouter()

const redirectToPricing = () => {
  closeModal()
  router.push('/pricing')
}

const isModalOpenComputed = computed(() => {
  return messageStore.showCreditsModal || conversationsStore.showCreditsModal || explanationStore.showCreditsModal
})

function closeModal () {
  messageStore.showCreditsModal = false
  conversationsStore.showCreditsModal = false
  explanationStore.showCreditsModal = false
}
</script>
<template>
  <div
    v-if="isModalOpenComputed"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
  >
    <div class="bg-white rounded-lg shadow-lg w-96 p-6">
      <h2 class="text-lg font-semibold text-gray-800">{{ $t('creditsModal.insufficientCredits') }}</h2>
      <p class="mt-2 text-sm text-gray-600">
        {{ $t('creditsModal.creditsMessage') }}
      </p>
      <div class="mt-4 flex justify-end space-x-2">
        <button
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
          @click="closeModal()"
        >
          {{ $t('creditsModal.cancel') }}
        </button>
        <button
          class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded hover:bg-blue-700"
          @click="redirectToPricing"
        >
          {{ $t('creditsModal.buyCredits') }}
        </button>
      </div>
    </div>
  </div>
</template>
